const elevator = {
  restaurant: { elevatorx: 90, elevatory: 90 },
  gym: { elevatorx: 115, elevatory: 40 },
  library: { elevatorx: 277, elevatory: 63 },
  admin: { elevatorx: 241, elevatory: 95 },
  none: { elevatorx: 0, elevatory: 0 },
};

export default elevator;
